import { FlightTypeRegular } from '@lt/components/icons-react/checkout-flight-ticket';
import styled from 'styled-components';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 8px;
`;

export const StyledFlightTypeRegular = styled(FlightTypeRegular)`
  margin-right: 5px;
`;

export const CompanyName = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  text-align: left;

  color: #17181a;
`;

export const TitleWrapper = styled.div<{ parentWidth?: number }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minXs) {
      return 'flex-wrap: nowrap;';
    }
    return '';
  }}
`;

export const Title = styled<any>(CompanyName)`
  margin-right: 4px;
`;

export const StyledBubbleContent = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledBubbleText = styled.div`
  font-family: 'Backpack', serif;
  font-size: 12px;
  line-height: 14px;
`;

export const StyledBubbleLabel = styled.span<{ parentWidth?: number }>`
  color: #919499;
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth < CONTAINER_QUERY_BREAKPOINTS.minXs) {
      return 'display: none;';
    }
    return '';
  }}
`;
